// Libraries
import React from 'react';
import { useTranslation } from 'react-i18next';

// Enums
import { EngagementReportQuestionType } from 'engagementReport/enums/propTypes';

// Components
import GeolocationMap from 'engagementReport/components/geolocation/GeolocationMap';

const GeolocationReport = ({ question }) => {
  const { t } = useTranslation();
  const { data, location } = question;
  const isEmpty = data.length === 0;

  return (
    <div className="geolocation-report">
      {isEmpty && (
        <div className="basic-report__subtitle">{t('engagement_report.no_responses')}</div>
      )}
      {!isEmpty && <GeolocationMap data={data} location={location} />}
    </div>
  );
};

GeolocationReport.propTypes = {
  question: EngagementReportQuestionType.isRequired,
};

export default GeolocationReport;
